import backpack from '~/assets/icons/backpack_2.svg';
import bite from '~/assets/icons/bite.svg';
import pocket from '~/assets/icons/pocket.svg';
import item1 from '../../assets/images/1.png';
import item2 from '../../assets/images/2.png';
import item3 from '../../assets/images/3.png';
import item4 from '../../assets/images/4.png';

export const baitItems = [
	{ id: 0, icon: bite },
	{ id: 1, icon: item1 },
	{ id: 2, icon: item2 },
	{ id: 3, icon: item3 },
	{ id: 4, icon: item4 },
];

export const inventoryItems = [
	{ id: 1, icon: pocket },
	{ id: 2, icon: backpack },
];
